<ion-button color="success" (click)="onClick()">Rechercher sur Desmos</ion-button>
<span class="txt-message italic">
	<ion-icon class="no-result-icon" name="information-circle"></ion-icon>
	<ion-note class="lil-font">Renseignez les champs au complet.<br>
		- nom entier,<br>
		- date de naissance en JJ/MM/AAAA,<br>
		- 13 chiffres pour le N° de SS.
	</ion-note>
</span>